/** Supported TEMA market regions for copy / tool naming. */
export const TEMA_REGIONS = {
  IN: "in",
  US: "us",
};

function normalizeTemaRegion(raw) {
  const value = String(raw ?? "")
    .trim()
    .toLowerCase();
  if (value === "in" || value === "ind" || value === "india") {
    return TEMA_REGIONS.IN;
  }
  if (
    value === "us" ||
    value === "usa" ||
    value === "united-states" ||
    value === "united states"
  ) {
    return TEMA_REGIONS.US;
  }
  return TEMA_REGIONS.US;
}

/** Market region from TEMA_REGION / REACT_APP_TEMA_REGION (default: us). */
export function getTemaRegion() {
  const raw =
    process.env.REACT_APP_TEMA_REGION ?? process.env.TEMA_REGION ?? "";
  if (!String(raw).trim()) {
    return TEMA_REGIONS.US;
  }
  return normalizeTemaRegion(raw);
}

export function isUsTemaRegion() {
  return getTemaRegion() === TEMA_REGIONS.US;
}
